import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import styled from 'foundations-theming/utils';
import { forwardRef } from 'react';
import { useIsOverrideLocaleActive } from '../hooks/useIsOverrideLocaleActive';
import { jsx as _jsx } from "react/jsx-runtime";
const DisabledWrapper = styled.div.withConfig({
  displayName: "withOverrideLocaleDisablePM__DisabledWrapper"
})({
  cursor: 'not-allowed',
  '& > *': {
    pointerEvents: 'none'
  }
});
export function withOverrideLocaleDisablePM(WrappedComponent) {
  var _WrappedComponent$dis;
  const wrapper = /*#__PURE__*/forwardRef((props, ref) => {
    const isOverrideLocaleActive = useIsOverrideLocaleActive();
    if (isOverrideLocaleActive) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "publicPricingPage.merchCard.cta.overrideLocaleDisabledTooltip"
        }),
        children: /*#__PURE__*/_jsx(DisabledWrapper, {
          children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
            disabled: true,
            ref: ref
          }))
        })
      });
    }
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
      ref: ref
    }));
  });
  wrapper.displayName = `withOverrideLocaleDisablePM(${(_WrappedComponent$dis = WrappedComponent.displayName) !== null && _WrappedComponent$dis !== void 0 ? _WrappedComponent$dis : WrappedComponent.name})`;
  return wrapper;
}